// extracted by mini-css-extract-plugin
module.exports = {"ShoppingCard":"Styles_ShoppingCard__1R66F","TopRow":"Styles_TopRow__yOmyA","HeadRow":"Styles_HeadRow__2rtVu"};